import * as React from "react";
import * as _ from "lodash";
import { IPastPsychiatricHistory } from "@curefit/ehr-common";
import TemplatedList from "../../TemplatedList"
import ModelFactory from "../../../models/ModelFactory"
import IStaticDataValue from "../../../../../common/models/IStaticDataValue";
import {ITypeFormQuestionnaire} from "../../../models/ITypeFormQuestionnaire";
import TypeFormContainer from "../../../containers/TypeFormContainer";
import ToggleButtonList from "../../ToggleButtonList";
import {default as CustomHeader, ICustomHeaderInfo} from "../../utils/CustomHeader";
import {QuestionType} from "../../../utils/AppConstants";
import IPPHUI from "../../../models/IPPHUI";
import IDiagnosticSuggestions from "../../../models/IDiagnosticSuggestions";
import IMedicineSuggestions from "../../../models/IMedicineSuggestions";

/**
 * Created by Rishabh Kumar on 03/08/18.
 */

const PsychiatricHistoryEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "year", display: "WHEN"},
    {label: "name", display: "CHIEF COMPLAINTS"},
    {label: "name", display: "DIAGNOSIS"},
    {label: "name", display: "MEDICATION"},
    {label: "frequency", display: "FREQUENCY"},
    {label: "duration", display: "DURATION"},
    {label: "comments", display: "COMMENTS"},
];

const toggleButtonItems: IToggleItem[] = [
    {displayValue: "Yes", internalValue: true },
    {displayValue: "No", internalValue: false }
];

interface IToggleItem {
    displayValue: string,
    internalValue: boolean
}

export interface PsychiatricHistoryEditorProps {
    staticConditions?: IStaticDataValue[],
    updatedPPH: {item: IPastPsychiatricHistory}[],
    updatePPH: (updatedPPH: {item: IPastPsychiatricHistory}[]) => void;
    questionnaire?: ITypeFormQuestionnaire[];
    questionIdList?: string[];
    fetchStaticSymptomData: (name: string) => Promise<any>;
    fetchStaticDiseasesData?: (input: string) => Promise<IDiagnosticSuggestions[]>;
    fetchMedicineByGenericName: (name: string) => Promise<IMedicineSuggestions[]>;
}

interface PsychiatricHistoryEditorState {
    showPPHDetails: boolean
}

class PsychiatricHistoryEditor extends React.Component<PsychiatricHistoryEditorProps, PsychiatricHistoryEditorState> {

    constructor(props: PsychiatricHistoryEditorProps) {
        super(props);
        let showPPHDetailsStatus = this.props.updatedPPH && this.props.updatedPPH.length > 0;
        this.state = {
            showPPHDetails: showPPHDetailsStatus
        }
    }

    onPPHDataRemove = (index: number) => {
        let currUpdatedPPH = Object.assign([], this.props.updatedPPH);
        currUpdatedPPH.splice(index, 1);
        this.props.updatePPH(currUpdatedPPH);
    }

    onPPHDataChange = (updatedItem: {item: IPPHUI}, index: number) => {
        let currUpdatedPPH = Object.assign([], this.props.updatedPPH);
        if (index >= currUpdatedPPH.length) {
            // this will be executed when adding a new row
            let newPPHItem = ModelFactory.createNewPPHUIItem();
            newPPHItem.appointmentMonth = updatedItem.item.appointmentMonth;
            newPPHItem.appointmentYear = updatedItem.item.appointmentYear;
            newPPHItem.chiefComplaintsDisplayValue = updatedItem.item.chiefComplaintsDisplayValue;
            newPPHItem.diagnosisDisplayValue = updatedItem.item.diagnosisDisplayValue;
            currUpdatedPPH.push(updatedItem)
        } else {
            // this will be executed when editing an existing row
            currUpdatedPPH[index] = updatedItem;
            _.map(currUpdatedPPH[index].item.items, (item: IPastPsychiatricHistory) => {
                item.appointmentMonth = updatedItem.item.appointmentMonth;
                item.appointmentYear = updatedItem.item.appointmentYear;
                item.chiefComplaintsDisplayValue = updatedItem.item.chiefComplaintsDisplayValue;
                item.diagnosisDisplayValue = updatedItem.item.diagnosisDisplayValue;
            })
        }
        this.props.updatePPH(currUpdatedPPH);
    }

    appendToRemoveKey = (pphItems: {item: IPPHUI}[]) => {
        let pphDataToReturn = pphItems;
        _.map(pphDataToReturn, (pph: {item: any}) => {
            if (pph.item.items.length === 0) {
                pph.item.showRemove = true;
            } else if (pph.item.items.length === 1) {
                if (ModelFactory.isConditionDetailsEmpty(pph.item.items[0]))
                    pph.item.showRemove = true;
                else
                    pph.item.showRemove = false;
            } else {
                pph.item.showRemove = false;
            }
        });
        return pphDataToReturn;
    };

    handleToggleButtonClick = (value: boolean) => {
        this.setState({ showPPHDetails: value })
    }

    render() {
        const { showPPHDetails } = this.state;
        let selectedItem = [showPPHDetails];
        return (
            <div className="past-psychiatric-history-editor">
                {
                    !_.isEmpty(this.props.questionnaire) &&
                    <TypeFormContainer typeFormData={this.props.questionnaire} questionIdList={this.props.questionIdList}/>
                }
                <div className={"psychiatric-history-enable-wrapper"}>
                    <div className={"psychiatric-history-toggle-wrapper in-blk"}>
                        <span className={"in-blk"}>{"Have you seen a psychiatrist/therapist before?"}</span>
                        <div className={"psychiatric-history-toggle-buttons-wrapper in-blk"}>
                            <ToggleButtonList listItems={toggleButtonItems} selectedItems={selectedItem} onSelectionChange={(item) => {this.handleToggleButtonClick(item)}} type={QuestionType.BOOLEAN_TOGGLE} />
                        </div>
                    </div>
                </div>
                {showPPHDetails && <CustomHeader headerInfos={PsychiatricHistoryEditorHeaderInfos} rootCls={"psychiatric-header"}/>}
                {showPPHDetails && <div className={"psychiatric-editor-values"}>
                    <TemplatedList templateName={"psychiatric"} commonProps={{fetchStaticSymptomData: this.props.fetchStaticSymptomData, fetchStaticDiseasesData: this.props.fetchStaticDiseasesData, fetchMedicineByGenericName: this.props.fetchMedicineByGenericName}}
                                   defaultItem={{item: ModelFactory.createNewPsychiatricHistoryDetailItem()}}
                                   // listItems={this.appendToRemoveKey(this.props.updatedPPH)}
                                   listItems={this.props.updatedPPH}
                                   onItemRemove={this.onPPHDataRemove}
                                   onItemChange={this.onPPHDataChange}
                                   hideRemoveBtn={false}
                    />
                </div>}
            </div>
        );
    }
}

export default PsychiatricHistoryEditor